// language=GraphQL
export const ALL_WEBHOOK_CONFIGS_QUERY = `query Query {
  webhookConfigs: travelWebhookConfigs {
    id
    enabled
    url
  }
}`

// language=GraphQL
export const SINGLE_WEBHOOK_CONFIG_QUERY = `query Query($id: ID!) {
  webhookConfig: travelWebhookConfig(id: $id) {
    id
    enabled
    url
  }
}`

// language=GraphQL
export const CREATE_WEBHOOK_CONFIG_MUTATION = `
  mutation Mutation($input: CreateTravelWebhookConfigInput) {
    webhookConfig: createTravelWebhookConfig(input: $input) {
      id
      enabled
      url
    }
  }`

// language=GraphQL
export const UPDATE_WEBHOOK_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateTravelWebhookConfigInput) {
    webhookConfig: updateTravelWebhookConfig(input: $input) {
      id
      enabled
      url
    }
  }`

// language=GraphQL
export const DELETE_WEBHOOK_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTravelWebhookConfigInput) {
    deleteTravelWebhookConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_WEBHOOK_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTravelWebhookConfigInput) {
    forceDeleteTravelWebhookConfig(input: $input) {
      success
    }
  }`
// language=GraphQL
export const WEBHOOK_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false) {
  groupedDependents: travelWebhookConfigDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
  }
}`
